import { IAppState } from 'shared/common/state';

export const customLabelSelector = (state: IAppState): string => {
  const offer = state.results.offers[0];

  return offer?.gaLabel || '';
};
